<template>
  <div class="do-subs">
    <transition name="fadeOut">
      <DoSplash v-if="isInitialLoading" key="initial-splash"></DoSplash>
    </transition>
    <div class="do-subs__header">
      <div class="do-subs__header__div">
        <h1>Vikardækning</h1>
        <DoChangeDayNav
          :date="date"
          @today="setDate('today')"
          @prev="setDate('prev')"
          @next="setDate('next')">
        </DoChangeDayNav>
        <span>{{ dateFormatted }}</span>
        <div class="do-spinner" v-if="isLoadingEvents"></div>
      </div>
      <div class="do-subs__header__div">
        <label>Antal fraværende: {{ absentUsers.length }}</label>
      </div>
    </div>
    <div class="do-subs__body">
      <Scheduler
        :events="events"
        :klassCalendars="klassCalendars"
        :userCalendars="userCalendars"
        :allCalendarsInHash="allCalendarsInHash">
      </Scheduler>
    </div>
  </div>
</template>


<script>
import docendo from '../../docendo'
import Loader from '../common/Loader.vue'
import DoChangeDayNav from '../common/DoChangeDayNav.vue'
import moment from 'moment'
import DoSplash from '../common/DoSplash.vue'
import eventbus from '../../eventbus'
import Scheduler from '../Substitution/Scheduler.vue'
import {mapGetters} from 'vuex'
export default {
  components: {Scheduler, DoSplash, DoChangeDayNav, Loader},
  data () {
    return {
      isLoadingEvents: false,
      events: [],
      date: moment(),
      activeUserIds: [],
      isInitialLoad: true
    }
  },
  computed: {
    ...mapGetters([
      'klassCalendars',
      'userCalendars',
      'allCalendarsInHash'
    ]),
    schoolId () {
      return this.$route.params.school_id ? this.$route.params.school_id : this.$store.getters.schoolId
    },
    dateFormatted () {
      return moment(this.date).format('DD-MM-YYYY')
    },
    users () {
      return this.$store.getters.usersSortedOnName
    },
    allUsersInCalIdHash () {
      return this.$store.getters.allUsersInCalIdHash
    },
    isLoadingSchoolCalenders () {
      return this.$store.state.isLoadingSchoolCalenders
    },
    isLoadingAllUsers () {
      return this.$store.state.isLoadingAllUsers
    },
    isInitialLoading () {
      return this.isLoadingSchoolCalenders || this.isLoadingAllUsers
    },
    eventsInHash () {
      const events = this.events
      return events.reduce((obj, item) => {
        obj[item.id] = item
        return obj
      }, {})
    },
    eventsInCalIdsHash () {
      const calIds = {}
      this.events.forEach(event => {
        event.calendar_events.forEach(calEvent => {
          const cal = calIds[calEvent.calendar_id]
          if (!cal) {
            calIds[calEvent.calendar_id] = [event]
          } else {
            calIds[calEvent.calendar_id].push(event)
          }
        })
      })
      return calIds
    },
    usersWithEvents () {
      if (this.isInitialLoading) {
        return []
      }
    },
    absentUsers () {
      if (this.isInitialLoading) {
        return []
      }
      return []
      /*
      const absentEvents = this.events.filter(event => event.event_type === 'absence')
      const absentUserCalIds = []
      absentEvents.forEach(calEvent => {
        const calId = calEvent.calendar_id
        const idx = absentUserCalIds.indexOf(calId)
        if (idx < 0) {
          absentUserCalIds.push(calId)
        }
      })
      return absentUserCalIds.map(calId => {
        const user = this.allUsersInCalIdHash[calId]
        const dontShow = ['absence', 'presence']
        const userEvents = this.eventsInCalIdsHash[calId]
        const userEventsFiltered = userEvents.filter(event => dontShow.indexOf(event.event_type) < 0)
        const userEventsWithVProps = userEventsFiltered.map(event => {
          return {
            ...event,
            v_time: moment(event.start).format('LT') + ' - ' + moment(event.end).format('LT'),
            v_klass: event.calendar_events.filter(cal => cal && (cal.calendar_type === 'klass' || cal.calendar_type === 'other')).map(cal => cal.name).join(', '),
            v_substitutes: event.calendar_events.filter(cal => cal && (cal.substitute_for_user_id === user.id)),
            v_status: this.getStatus(event, user)
          }
        }).sort((a, b) => moment(a.start).unix() - moment(b.start).unix())
        return {
          ...user,
          v_events: userEventsWithVProps
        }
      }).sort((a, b) => a.name.localeCompare(b.name))
       */
    }
  },
  methods: {
    getIsUserSubstituted (event, user) {
      return event.calendar_events.some(calEvent => calEvent.substitute_for_user_id === user.id)
    },
    getStatus (event, user) {
      const isSubstituted = this.getIsUserSubstituted(event, user)
      if (isSubstituted) {
        return 1
      }
      const status = event.substitution_status ? JSON.parse(event.substitution_status) : {}
      const userStatus = status[user.user_calendar_id] ? status[user.user_calendar_id]['status'] : 0
      return userStatus
    },
    setActiveUser (user) {
      this.activeUserIds = [user.id]
    },
    onChangeSubstitute (updateObj) {
      this.submit([updateObj])
    },
    onChangeStatus (updateObj) {
      const event = updateObj.event
      const user = updateObj.user
      const val = updateObj.val * 1
      const status = event.substitution_status ? JSON.parse(event.substitution_status) : {}
      const statusData = {...status}
      if (val === 0) {
        delete statusData[user.user_calendar_id]
      } else {
        statusData[user.user_calendar_id] = {status: val}
      }
      docendo.updateEvent(event.school_id, event.id, {substitution_status: statusData}, success => {
        this.readEvents()
      })
    },
    submit (dbEventsWithSubs) {
      const updates = {}
      dbEventsWithSubs.forEach(eventMap => {
        const eventId = eventMap.event_id
        const event = this.eventsInHash[eventId]
        const schoolId = event && event.school_id ? event.school_id : null
        if (!updates[schoolId]) {
          updates[schoolId] = [eventMap]
        } else {
          updates[schoolId].push(eventMap)
        }
      })
      const successTxt = this.$t('vue2.substitution.lessons_updated')
      const errorTxt = this.$t('vue2.common.something_went_wrong')
      Object.keys(updates).forEach(schoolId => {
        docendo.updateEvents(schoolId, updates[schoolId], success => {
          eventbus.toast = {text: successTxt, success: true}
          this.readEvents()
        }, failure => {
          eventbus.toast = {text: errorTxt, success: false}
        })
      })
    },
    setDate (inputDate) {
      let date = inputDate
      if (date === 'today') {
        date = moment()
      }
      if (date === 'prev') {
        date = moment(this.date).subtract(1, 'days')
      }
      if (date === 'next') {
        date = moment(this.date).add(1, 'days')
      }
      this.date = date
      setTimeout(_ => {
        this.readEvents()
      }, 100)
    },
    readEvents () {
      this.isInitialLoad = true
      this.events = []
      this.isLoadingEvents = true
      const schoolIds = [this.schoolId]
      docendo.listEventsForSchools(
        schoolIds,
        this.date,
        (success) => {
          const events = success && success.length > 0 ? JSON.parse(success) : []
          this.setEventsWithMetaData(events)
          this.isLoadingEvents = false
        },
        (failure) => {
          console.log('something went wrong')
        }
      )
    },
    setEventsWithMetaData (events) {
      this.events = events.map(event => {
        return {
          ...event,
          vTime: moment(event.start).format('LT') + ' - ' + moment(event.end).format('LT'),
          vKlasses: event.calendar_events.filter(cal => cal && (cal.calendar_type === 'klass')).map(cal => cal.name).join(', '),
          vSubstitutes: [] // event.calendar_events.filter(cal => cal && (cal.substitute_for_user_id === user.id)),
          // vStatus: this.getStatus(event, user)
        }
      }).sort((a, b) => moment(a.start).unix() - moment(b.start).unix())
    }
  },
  mounted () {
    this.readEvents()
  }
}
</script>

<style scoped>
.do-subs__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid
}

.do-subs__header__div {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.do-subs__body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
}

.do-subs__body__container {
  display: flex;
  align-items: stretch;
  background: #fff;
}

.do-dot {
  border: 1px solid #222;
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.do-dot.do-dot--green {
  background-color: #3ecf8e;
  border-color: #3ecf8e;
}

.do-subs__user__subs {
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
}

.sub-badge {
  background: #f4f4f5;
  border-radius: 4px;
  display: inline-flex;
  font-size: 11px;
  font-weight: 400;
  padding: .15rem .35rem;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// Substitution.vue?378edf86